import Select from "react-select";
import OptionFormatter from "../../../../components/OptionFormatter";
import {
  IGlobalProduct,
  IRequestorMarket,
  ITcc,
  TccCompositionRegionInfo,
} from "../../../../types/data.interface";
import useRequestorMarket from "../../../../hooks/useRequestorMarket";
import {
  formatRequestorMarketIntoOption,
  getRequestorMarkets,
} from "../../../../helpers/requestor-market.helper";
import { ProductMaster } from "hooks/useProductMaster";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import { CreateMpnActions } from "../../states/create";
import { CreateMpnActionTypes } from "../../states/create/data";
import { GlobalContext } from "../../../../context/GlobalContextProvider";
import { useContext } from "react";

export type RequestorProps = {
  selectedGP?: IGlobalProduct | null;
  selectedTcc?: ITcc | null;
  requestorMarket?: IRequestorMarket;
  setRequestorMarket?: (market: IRequestorMarket) => void;
  setUnsavedChangesToTrue?: () => void;

  setChangedImportValues?: (didChange: boolean) => void;
  setSelectedTccCompositionRows?: (rows: number[]) => void;
  setSelectedMoldIndexes?: (indexes: string[]) => void;
  setSelectedTccCompositionRegion?: (
    tccCompositionRegion: TccCompositionRegionInfo | null,
  ) => void;
  setSelectedPM?: (pm: ProductMaster | null) => void;
  readOnly?: boolean;
};

const RequestorInfo = ({
  selectedGP,
  selectedTcc,
  requestorMarket,
  setRequestorMarket,
  setUnsavedChangesToTrue,
  setChangedImportValues,
  setSelectedTccCompositionRows,
  setSelectedMoldIndexes,
  setSelectedTccCompositionRegion,
  setSelectedPM,
  readOnly,
}: RequestorProps) => {
  const { data, isLoading: isRequestorMarketsLoading } = useRequestorMarket();

  const {state, dispatch} = useCreateMpnStore()
  
   const {
     fusionSuppliers: { data: fusionSupplierData },
   } = useContext(GlobalContext);

  const handleRequestorMarketChange = (e: any) => {
    // dispatch(CreateMpnActions.setRequestorInfo(e.value))

    if (e) {
      dispatch(
        CreateMpnActions.setStateValue(CreateMpnActionTypes.SET_REQUESTOR_INFO, e.value)
      )
      
        const fusionSupplierIndex = fusionSupplierData.findIndex(
          (f: any) => f.res_pm_market_id === e.value?.id,
        );
        const fusionSupplierDefault = fusionSupplierData.find(
          (f: any) => f.res_pm_market_id == 0,
        );

        if (fusionSupplierIndex >= 0) {
          dispatch(
            CreateMpnActions.setStateValue(
              CreateMpnActionTypes.SET_FUSION_SUPPLIER_ID,
              fusionSupplierData[fusionSupplierIndex],
            ),
          );
        } else {
          dispatch(
            CreateMpnActions.setStateValue(
              CreateMpnActionTypes.SET_FUSION_SUPPLIER_ID,
              fusionSupplierDefault,
            ),
          );
        }

      if (setRequestorMarket) {
        // setRequestorMarket(e.value);
      }
    } else {
      CreateMpnActions.setStateValue(CreateMpnActionTypes.SET_REQUESTOR_INFO, null)
      if (setRequestorMarket) {
        // setRequestorMarket({ id: "", short_name: "", full_name: "" });
      }
    }

    if (setChangedImportValues) {
      setChangedImportValues(true);
    }
    if (setSelectedTccCompositionRows) {
      setSelectedTccCompositionRows([]);
    }
    if (setSelectedMoldIndexes) {
      setSelectedMoldIndexes([]);
    }
    if (setSelectedTccCompositionRegion) {
      setSelectedTccCompositionRegion(null);
    }
    if (setSelectedPM) {
      setSelectedPM(null);
    }
    if (setUnsavedChangesToTrue) {
      setUnsavedChangesToTrue();
    }
  };

  return (
    <>
      <div>
        <div className="card-header my-2 rounded d-flex ">
          <h6 className="m-0 text-primary fw-bold">Requestor Information</h6>
        </div>

        <div className="col-lg-4 form-group">
          <label className="form-label">
            Requestor Location <span className="red-text fw-bold">*</span>
          </label>
          <Select
            options={getRequestorMarkets(data)}
            onChange={handleRequestorMarketChange}
            formatOptionLabel={OptionFormatter}
            value={formatRequestorMarketIntoOption(state.requestorInfo)}
            classNamePrefix="react-select"
            placeholder=""
            isClearable
            isLoading={isRequestorMarketsLoading}
            components={{
              IndicatorSeparator: () => null,
            }}
            isDisabled={readOnly || state.mpnRequest.status === "SUBMITTED"}
          />
        </div>
      </div>
    </>
  );
};

export default RequestorInfo;
